import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (max-width: 768px) {
      display: grid;
    }

    .signup-content {

        h3 {
            color: #002666;
            font-weight: bold;
        }

        ul {
            list-style-type: none;
            padding: 0;
            margin: 0;

            li {
                margin-bottom: 20px;
            }

            input {
                border: 2px solid #303030;
                border-radius: 10px;
                width: 100%;
                height: 80px;
                font-size: 24px;
                padding-left: 20px;
                color: #bcbcbc;
            }
        }
    }

    .signup-top-section {
        padding: 70px 0;

        form {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            @media (max-width: 768px) {
              flex-direction: column;
              align-items: center;
          }
        }

        .profile-photo-upload-button-wrapper {
            position: relative;
            overflow: hidden;
            display: inline-block;
        }

        .profile-photo-upload-button-wrapper input[type=file] {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            font-size: 100px;
        }
    }

    .signup-top-section-left{
        width: 35%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        input {
            border: none;
            padding: 10px 40px;
            width: 265px;
            background: #ce1720;
            color: #fff;
            border-radius: 10px;
            font-size: 24px;
            font-weight: bold;
        }
    }

    #signup_photo_img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }

    .signup-photo-circle {
        border: 3px dashed #303030;
        color: #303030;
        height: 350px;
        width: 350px;
        margin: 40px 0;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
            font-size: 18px;
        }

        i {
            font-size: 50px;
            margin-bottom: 15px;
        }
    }

    .signup-top-section-right{
        width: 60%;

        @media (max-width: 768px) {
              width: 100%;
          }
    }

    .signup-form-row {
        display: flex;
        flex-direction: row;

        div {
            width: 100%;
        }
    }

    .signup-mid-section {
        width: 90%;

        @media (max-width: 768px) {
              flex-direction: column;
              align-items: center;
          }

        h1 {
            color: #fff;
            font-size: 48px;
            margin-top: 70px;
            margin-bottom: 100px;
            font-weight: bold;
        }
    }
    .signup-mid {
      display: flex;
        flex-direction: row;
        justify-content: space-between;

        @media (max-width: 768px) {
              flex-direction: column;
              align-items: center;
          }
    }


    .sms-checkbox-wrapper {
        border: 2px solid #303030;
        border-radius: 5px;
        padding: 5px;
        margin-right: 10px;
        cursor: pointer;
    }

    .signup-plan-card {
        background: #fff;
        width: 31%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        text-align: center;

        @media (max-width: 768px) {
          width: 70%;
          margin-bottom: 20px;
        }

        h3 {
            border-bottom: 2px solid #e7e6e6;
            font-size: 40px;
            padding-top: 30px;
            padding-bottom: 15px;
        }

        h2 {
            border-bottom: 2px solid #e7e6e6;
            font-size: 60px;
            margin-bottom: 20px;
            padding-bottom: 10px;
            font-weight: bold;
        }

        span {
            font-size: 32px;
            font-weight: normal;
            position: relative;
            top: -20px;
        }

        strong {
            font-size: 32px;
            font-weight: normal;
            font-variant-position: sub;
        }

        p {
            border-bottom: 2px solid #e7e6e6;
            color: #737373;
            font-size: 24px;
            margin: 20px 50px 0 50px;
        }

        button {
            border: none;
            border-radius: 10px;
            background: #009fea;
            color: #fff;
            font-size: 22px;
            margin-top: 30px;
            margin-bottom: 60px;
            padding: 15px 60px;
        }

        /* .select-container {
            border: 1px dashed red;
        } */

        /*.select-container:after {
            content: '\f078';
            font: normal normal normal 17px/1 FontAwesome;
        } */

        i {
            color: #009fea;
            font-size: 30px;
            position: relative;
            bottom: 32px;
            left: 130px;
        }

        select {
            width: 110%;
            border: none;
            background: rgba(0, 0, 0, 0);
            color: #737373;
            font-size: 24px;
            /* Remove ícone dropdown padrão */
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
        }

        /* Remove ícone dropdown padrão no IE11.
           Um hack pras bosta da Microsoft... */
        select::-ms-expand {
            display: none;
        }

        select:hover {
            background: #009fea;
            color: #fff;
        }

        &:hover {
            background: #009fea;
            color: #fff;
            cursor: pointer;

            h2, h3, p {
                border-color: #00b4e9;
                color: #fff;
            }

            button {
                background: #0e0e0e;
            }

            select {
              color: white;
            }

            i {
                color: white;
            }
        }
    }

    .signup-plan-card-selected {
        background: #009fea;
        color: #fff;

        h2, h3, p {
            border-color: #00b4e9;
            color: #fff;
        }

        button {
            background: #0e0e0e;
        }

        select {
          color: white;
        }

        i {
            color: white;
        }
    }

    .signup-bot-section {
        padding: 110px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        button {
            border: none;
            border-radius: 10px;
            background: #ce1720;
            color: #fff;
            font-size: 28px;
            font-weight: bold;
            padding: 20px 80px;
        }

        p {
            color: #fff;
            font-size: 22px;
            position: relative;
            margin-bottom: -30px;
            top: 30px;
        }
    }
`;
